import { render, staticRenderFns } from "./Mentorships.vue?vue&type=template&id=1aeedbfa&"
import script from "./Mentorships.vue?vue&type=script&lang=js&"
export * from "./Mentorships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports